module.exports = __webpack_public_path__ + "static/performance_measurement-7ac56bb8c4854789fa0c087f3ec11fbf.png";